import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchOrders, OrderQueryParams } from "../../api/orders.api";
import { ordersKeys } from "../../queryKeys";

export const useFetchOrders = (params: OrderQueryParams) => {
  return useQuery({
    queryKey: [
      ...ordersKeys.all,
      {
        search: params.search,
        status: params.status,
        payment_status: params.payment_status,
        date_from: params.date_from,
        date_to: params.date_to,
        page: params.page,
        page_size: params.page_size,
      },
    ],
    queryFn: () => fetchOrders(params),

    placeholderData: keepPreviousData,

    staleTime: 1000 * 60 * 1,
    refetchOnWindowFocus: false,

    retry: 1,
  });
};